import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import { useTranslation } from 'react-i18next';
import { ReactSVG } from 'react-svg';
import * as icons from '../../assets/images/toolbarIcons/_toolbarIcons';

const Arrangement = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedEntity = useSelector(state => state.design.selectedEntity);
  const { activePageRef } = useContext(DesignContext);

  const moveForward = () => {
    dispatch(
      designActions.changeEntityArrange(activePageRef.current, selectedEntity.id, 'forward'),
    );
  };

  const moveBackward = () => {
    dispatch(
      designActions.changeEntityArrange(activePageRef.current, selectedEntity.id, 'backward'),
    );
  };

  const moveToFront = () => {
    dispatch(
      designActions.changeEntityArrange(activePageRef.current, selectedEntity.id, 'toFront'),
    );
  };

  const moveToBack = () => {
    dispatch(designActions.changeEntityArrange(activePageRef.current, selectedEntity.id, 'toBack'));
  };

  return (
    <div className="toolsHolderContainer arrangement">
      {/* {!Array.isArray(selectedEntity.id) && ( */}
      <div className="row">
        <button className="ui button" title="Bring Front" onMouseDown={moveToFront}>
          <ReactSVG className="svgIcon" src={icons.bringFront} />
          <span>{t('bringFront')}</span>
        </button>
        <button className="ui button" title="Bring Back" onMouseDown={moveToBack}>
          <ReactSVG className="svgIcon" src={icons.sendBack} />
          <span>{t('bringBack')}</span>
        </button>
      </div>
      {/* )} */}
      <div className="row">
        <button className="ui button" title="Forward" onMouseDown={moveForward}>
          <ReactSVG className="svgIcon" src={icons.bringForward} />
          <span>{t('toForward')}</span>
        </button>
        <button className="ui button" title="Backward" onMouseDown={moveBackward}>
          <ReactSVG className="svgIcon" src={icons.sendBackward} />
          <span>{t('toBackward')}</span>
        </button>
      </div>
    </div>
  );
};

export default Arrangement;
